import { useEffect } from 'react';

// Leave the document defaults intact for Classic and restore them when this shell unmounts.
export default function useBranding(enabled = true) {
	useEffect(() => {
		if (!enabled) return undefined;
		const title = document.title;
		const links = [...document.querySelectorAll('link[rel~="icon"], link[rel="manifest"]')];
		const originals = links.map(link => ({ link, href: link.getAttribute('href'), type: link.getAttribute('type'), sizes: link.getAttribute('sizes') }));
		document.title = 'APWorks';
		links.forEach(link => {
			const icon = link.rel.split(' ').includes('icon');
			link.href = icon ? '/images/apworks-symbol.svg' : '/apworks.webmanifest';
			if (icon) { link.type = 'image/svg+xml'; link.setAttribute('sizes', 'any'); }
		});
		return () => {
			document.title = title;
			originals.forEach(({ link, ...attrs }) => Object.entries(attrs).forEach(([name, value]) => {
				if (value == null) link.removeAttribute(name); else link.setAttribute(name, value);
			}));
		};
	}, [enabled]);
}
